<template>
  <div id="app">
    <Nav></Nav>

    <section class="main-content columns is-fullheight">
      <Menu v-if="$store.state.auth.role.level === 1"></Menu>
      <CustomerMenu v-if="$store.state.auth.role.level === 3"></CustomerMenu>

      <div class="container">
        <div class="section">
          <router-view />
        </div>
      </div>
    </section>

    <transition name="fade">
      <div
        v-show="$store.state.notification.show"
        class="columns is-mobile is-centered"
      >
        <div
          class="notification push-forward column is-one-quarter-desktop is-unselectable"
          :class="$store.state.notification.css"
          style="position:fixed !important; bottom:10px !important;"
          @click="ToggleNotification(true)"
        >
          <div
            style="margin-right: 10px; display:inline-block"
            v-html="$store.state.notification.text"
          ></div>

          <button
            v-show="!$store.state.notification.timeout"
            class="delete"
            @click="ToggleNotification(false)"
          ></button>
          <span
            v-show="$store.state.notification.timeout"
            class="is-pulled-right"
            >({{ $store.state.notification.timeout / 1000 }})</span
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Nav from "@/components/singles/BNav/component.vue";
import Menu from "@/components/singles/BMenu/component.vue";
import CustomerMenu from "@/components/main/user/menu.vue";

export default {
  name: "",
  components: { Nav, Menu, CustomerMenu },
  data() {
    return {};
  },
  created() {
    this.$helpers.GetAuthInfo();
  },
  mounted() {},
  methods: {
    ToggleNotification(checkTimeout) {
      if (!checkTimeout || this.$store.state.notification.timeout) {
        this.$store.state.notification.show = !this.$store.state.notification
          .show;
      }
    }
  }
};
</script>
